var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { IconTickMarkOutlined, IconMoreInfoOutlined, IconCloseCircleOutlined } from "../../icons";
import { prefixCls } from "./Notification";
var typeToIcon = {
    success: IconTickMarkOutlined,
    info: IconMoreInfoOutlined,
    error: IconCloseCircleOutlined,
    warning: IconMoreInfoOutlined,
};
export var Panel = function (props) {
    var _a;
    var icon = props.icon, type = props.type, title = props.title, description = props.description, btn = props.btn;
    var iconNode = null;
    var noticePrefixCls = "".concat(prefixCls, "-notice");
    if (icon) {
        iconNode = _jsx("span", __assign({ className: "".concat(noticePrefixCls, "-icon") }, { children: icon }));
    }
    else if (type) {
        iconNode = React.createElement(typeToIcon[type] || null, {
            className: classNames("".concat(noticePrefixCls, "-icon"), "".concat(noticePrefixCls, "-icon-").concat(type)),
            size: "lg",
        });
    }
    return (_jsxs("div", __assign({ className: classNames((_a = {},
            _a["".concat(noticePrefixCls, "-with-icon")] = iconNode,
            _a)), role: "alert" }, { children: [iconNode, _jsx("div", __assign({ className: "".concat(noticePrefixCls, "-title") }, { children: title })), _jsx("div", __assign({ className: "".concat(noticePrefixCls, "-content") }, { children: description })), btn && _jsx("div", __assign({ className: "".concat(noticePrefixCls, "-btn") }, { children: btn }))] })));
};
Panel.propTypes = {
    icon: PropTypes.node,
    title: PropTypes.node,
    description: PropTypes.node,
    btn: PropTypes.node,
    type: PropTypes.oneOf(["success", "info", "error", "warning"]),
};
export default Panel;
